module.exports = __webpack_public_path__ + "img/1787895996923097090.5ad53556.png";